module.exports = __webpack_public_path__ + "static/media/Khan,28@2x.598d3e95.png";